import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";

export default function DocentesPorMateriaTablaAsignacion({ nombreMateria, devuelvo }) {
  const [docentesPorMateria, setDocentesPorMateria] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showMeses, setShowMeses] = useState(false);
  const [busqueda, setBusqueda] = useState("");

  const maxHorasPorTipo = {
    "Policia Actividad": 12,
    "Policia Retirado": 10,
    "Personal Civil": 36,
  };

  const nombreMeses = [
    "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
    "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
  ];

  useEffect(() => {
    if (!nombreMateria || !nombreMateria.nombreMateria || nombreMateria.nombreMateria.trim().length < 4) return;

    const controller = new AbortController();
    setLoading(true);
    setError(null);

    const fetchDocentes = async () => {
      try {
        const response = await axios.post(
          `https://wwwa.isepsantafe.net.ar/expedientes/docentes/getDocentesPorMateria/${encodeURIComponent(nombreMateria.nombreMateria)}`,
          {},
          { signal: controller.signal }
        );
        setDocentesPorMateria(response.data.docentesPorMateria || {});
      } catch (err) {
        if (!axios.isCancel(err)) {
          console.error(err);
          setError("No se han encontrado docentes con la incumbencia seleccionada");
        }
      } finally {
        setLoading(false);
      }
    };

    fetchDocentes();
    return () => controller.abort();
  }, [nombreMateria]);

  const generarMesesHorasLibres = (docente) => {
    const asignaciones = docente.asignacionMaterias || [];
    const fechaActual = new Date();
    const maxHoras = maxHorasPorTipo[docente.docenteTipo] || 12;

    return Array.from({ length: 12 }).map((_, i) => {
      const mesFecha = new Date(fechaActual.getFullYear(), fechaActual.getMonth() + i, 1);
      const mes = mesFecha.getMonth();
      const anio = mesFecha.getFullYear();

      let horasAsignadas = 0;

      asignaciones.forEach((a) => {
        if (a.estado?.toLowerCase() !== "activo") return;
        const inicio = new Date(a.fechaInicio);
        const fin = new Date(a.fechaFinalizacion);
        const primerDiaMes = new Date(anio, mes, 1);
        const ultimoDiaMes = new Date(anio, mes + 1, 0);

        if (fin >= primerDiaMes && inicio <= ultimoDiaMes) {
          horasAsignadas += Number(a.horasAsignadas || 0);
        }
      });

      const horasLibres = Math.max(maxHoras - horasAsignadas, 0);
      const ratio = horasLibres / maxHoras;

      let color = "green";
      if (ratio < 0.3) color = "red";
      else if (ratio < 0.7) color = "yellow";

      return {
        nombre: `${nombreMeses[mes]} ${anio}`,
        horasLibres,
        color,
      };
    });
  };

  const mesesColumnas = Array.from({ length: 12 }).map((_, i) => {
    const fecha = new Date();
    fecha.setMonth(fecha.getMonth() + i);
    return nombreMeses[fecha.getMonth()] + " " + fecha.getFullYear();
  });

  if (loading) return <p>Cargando docentes...</p>;
  if (error) return <p style={{ color: "red" }}>{error}</p>;
  if (!docentesPorMateria || Object.keys(docentesPorMateria).length === 0)
    return <p>No se han encontrado docentes con la incumbencia seleccionada</p>;

  const materiasConDocentesActivos = Object.entries(docentesPorMateria).filter(
    ([, data]) =>
      data.docentes.some(
        (d) => d.DocenteIncumbencia?.estado?.toLowerCase() === "activo"
      )
  );

  return (
    <div style={{ width: "100%", maxHeight: "70vh", overflowY: "auto", padding: 10 }}>

      {/* 🔎 BUSCADOR */}
      <input
        type="text"
        placeholder="Buscar por apellido o DNI..."
        value={busqueda}
        onChange={(e) => setBusqueda(e.target.value)}
        style={{
          width: "100%",
          padding: "8px",
          marginBottom: "10px",
          fontSize: "14px",
        }}
      />

      <button
        onClick={() => setShowMeses(!showMeses)}
        style={{ marginBottom: 10, padding: "6px 12px" }}
      >
        {showMeses ? "Ocultar Meses" : "Mostrar Meses"}
      </button>

      <div style={{ overflowX: "auto" }}>
        {materiasConDocentesActivos.map(([_, data]) => {
          let docentesActivos = data.docentes.filter((d) => {
            const estadoDocente = d.docenteEstado?.toLowerCase();
            const estadoIncumbencia = d.DocenteIncumbencia?.estado?.toLowerCase();
            return estadoDocente === "activo" &&
              (estadoIncumbencia === undefined || estadoIncumbencia === "activo");
          });

          // 🔎 FILTRO LOCAL
          if (busqueda.trim()) {
            const q = busqueda.toLowerCase();
            docentesActivos = docentesActivos.filter(
              (d) =>
                d.docenteApellido?.toLowerCase().includes(q) ||
                String(d.docenteDni).includes(q)
            );
          }

          docentesActivos.sort((a, b) =>
            a.docenteApellido.localeCompare(b.docenteApellido)
          );

          if (docentesActivos.length === 0) return null;

          return (
            <div key={data.id} style={{ marginBottom: 20 }}>
              <h3>
                {nombreMateria.nombreMateria} ({data.descripcion.trim()})
              </h3>

              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  fontSize: 13,
                  background: "#fff",
                }}
              >
                <thead>
                  <tr style={{ background: "#f1f1f1" }}>
                    <th>Apellido</th>
                    <th>Nombres</th>
                    <th>DNI</th>
                    {showMeses && mesesColumnas.map((m) => <th key={m}>{m}</th>)}
                  </tr>
                </thead>
                <tbody>
                  {docentesActivos.map((doc) => {
                    const mesesHoras = generarMesesHorasLibres(doc);
                    return (
                      <tr
                        key={doc.docenteDni}
                        onClick={() => devuelvo(doc)}
                        style={{ cursor: "pointer" }}
                      >
                        <td>{doc.docenteApellido}</td>
                        <td>{doc.docenteNombres}</td>
                        <td style={{ textAlign: "center" }}>{doc.docenteDni}</td>

                        {showMeses &&
                          mesesHoras.map((m) => (
                            <td
                              key={m.nombre}
                              style={{
                                backgroundColor: m.color,
                                color: m.color === "yellow" ? "#000" : "#fff",
                                textAlign: "center",
                                fontWeight: "bold",
                              }}
                            >
                              {m.horasLibres}
                            </td>
                          ))}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          );
        })}
      </div>
    </div>
  );
}
